import type { ReactNode } from "react";

export interface EmptyStateProps {
  readonly title: string;
  readonly description?: string;
  readonly action?: ReactNode;
  readonly testId?: string;
}

export function EmptyState(props: EmptyStateProps) {
  return (
    <div
      data-testid={props.testId ?? "empty-state"}
      className="rounded-2xl border border-pad-200 bg-white px-4 py-10 text-center"
    >
      <p className="pwz-eyebrow">Пусто</p>
      <p className="pwz-heading mt-2 break-words text-base">{props.title}</p>
      {props.description ? (
        <p className="mx-auto mt-1 max-w-prose break-words text-sm text-ink-600">
          {props.description}
        </p>
      ) : null}
      {props.action ? <div className="mt-5 flex justify-center">{props.action}</div> : null}
    </div>
  );
}
